import React from 'react';
import Img from "gatsby-image";
import Link from "gatsby-link";
import {OfferSection} from "../../styles/OfferStyles";

const translations = {
  en: {
    Development: 'E-commerce',
    Copywriting: 'Digital Marketing',
    Discover: 'Discover',
  },
  fr: {
    Development: 'E-commerce',
    Copywriting: 'Marketing Numérique',
    Discover: 'Découvrir',
  },
};
function getTranslation(key, locale) {
  return translations[locale] && translations[locale][key] ? translations[locale][key] : translations['en'][key];
};

export default function OfferBlocks({ data, pageContext }) {
  return (
    <OfferSection>
      <div className="section-block dev">
        <div className="section-text">
          <h3>{getTranslation('Development',pageContext)}</h3>
          <p>{data.dev_title[pageContext]}</p>
          <Link className={'button secondary'}
                to={pageContext === 'en' ? '/ecommerce' : `/${pageContext}/ecommerce`}>
            {getTranslation('Discover',pageContext)}
          </Link>
        </div>
        {data.dev_image.asset.fixed && (
          <Img fixed={data.dev_image.asset.fixed} />
        )}
      </div>
      <div className="section-block copy">
        {data.dev_image.asset.fixed && (
          <Img fixed={data.copy_image.asset.fixed} alt={getTranslation('Discover',pageContext)} />
        )}
        <div className="section-text">
          <h3>{getTranslation('Copywriting',pageContext)}</h3>
          <p>{data.copy_title[pageContext]}</p>
          <Link className={'button secondary'}
                to={pageContext === 'en' ? '/digital-marketing' : `/${pageContext}/digital-marketing`}>
            {getTranslation('Discover',pageContext)}
          </Link>
        </div>
      </div>
    </OfferSection>
  );
}
